<template>
  <div>
    <router-view />
    <div class="tabbarSpace"></div>
    <van-tabbar fixed active-color="#24a378"  v-model="active" :z-index="99" route>
      <van-tabbar-item to="/Home">
        <span>纪念</span>
        <i class="iconfont iconnav_home" slot="icon"></i>
      </van-tabbar-item>
      <van-tabbar-item to="/Explore">
        <span>广场</span>
        <i class="iconfont iconnav_square" slot="icon"></i>
      </van-tabbar-item>
      <van-tabbar-item to="/Discover">
        <span>发现</span>
        <i class="iconfont iconnav_discover" slot="icon"></i>
      </van-tabbar-item>
      <van-tabbar-item to="/User"> 
        <span>我</span>
        <i class="iconfont iconnav_me" slot="icon"></i>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
    export default {
       data() {
           return {
               active: 0,
               nowPath:'',  //当前路径
           }
       }, 
    }
</script>

<style scoped>

</style>